import React from 'react';
import { Button } from './Button';
export function Hero() {
  return <section className="bg-cream py-16 md:py-24 px-6" data-id="element-34">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-35">
        <div className="space-y-8" data-id="element-36">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal leading-tight" data-id="element-37">
            The 4-Hour Reset: Get Your Newborn to Sleep in 15 Minutes{' '}
            <span className="italic text-sage" data-id="element-38">
              (&nbsp;Without the Tears&nbsp;)
            </span>
          </h1>
          <h2 className="text-xl md:text-2xl font-sans text-charcoal/80 leading-relaxed" data-id="element-39">
            The "Biological Bridge" method for exhausted first-time moms who are
            tired of fighting the 2 AM battle.
          </h2>
          <div data-id="element-40">
            <Button className="w-full md:w-auto text-lg" onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-41">
              GET THE 4-HOUR RESET NOW
            </Button>
            <p className="mt-4 text-sm text-charcoal/60 font-sans" data-id="element-42">
              Immediate digital delivery. Access your sleep blueprint in 60
              seconds.
            </p>
          </div>
        </div>
        <div className="relative" data-id="element-43">
          <div className="absolute inset-0 bg-sage/20 rounded-3xl transform translate-x-4 translate-y-4" data-id="element-44"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pfCbAMiF6KZ33LsK62Hkxa/1.png" alt="The 4-Hour Reset Digital Guide on a tablet with a cup of tea" className="relative z-10 rounded-3xl shadow-xl w-full object-cover" data-id="element-45" />
        </div>
      </div>
    </section>;
}